import { Component, OnInit, ViewEncapsulation } from '@angular/core'; 
import { LugaresService } from '../services/lugares.service';
import { AutorizacionService } from '../services/autorizacion.service';
import { trigger, state, style, transition, animate} from '@angular/animations';

@Component({
  selector: 'app-lugares',
  templateUrl: './lugares.component.html',
  styleUrls: ['./lugares.component.css'],
  animations: [
    trigger('animacionLugares',[
      state('inicial', style({
          //ESTILOS CSS
          opacity:0,
          backgroundColor:'green',
          transform: 'rotate3d(0,0,0,0deg)'
      })),
      state('final', style({
          //ESTILOS CSS
          opacity:1,
          backgroundColor:'yellow',
          transform: 'rotate3d(5,10,20,30deg)'
      })),
      transition('inicial => final', animate(1000)),
      transition('final => inicial', animate(500))
    ]),
    trigger('animarDestacados',[
      state('inicial', style({
          //ESTILOS CSS
          opacity:0,
          transform:'translateX(70px)'
      })),
      state('final', style({
          //ESTILOS CSS
          opacity:1,
          transform:'translateX(0px)'
      })),
      transition('inicial => final', animate(2000)),
      transition('final => inicial', animate(500))
    ])
  ]
})

export class LugaresComponent implements OnInit {

//Objeto referencia de los lugares
  lugares = null; 
  state = 'inicial';
//Ubicacion para GoogleMaps
  lat:number =18.4377409;
  lng:number =-68.9855576;
  msg:any = null;
  loggedIn=false;

 animacionInicia(e){
  console.log('Inicio');
  console.log(e);
 } 

animacionTermina(e){
  console.log('Inicio');
  console.log(e);
 } 
  animar(){
    this.state = (this.state === 'final') ? 'inicial' : 'final';
  }



  constructor(private LugaresService: LugaresService, private AutorizacionService: AutorizacionService) { 

    LugaresService.getLugares()
      .valueChanges()
      .subscribe(lugares => {
        this.lugares = lugares;
      //setTimeout(()=>this.animar(),500)
    })

      //GET Method
/*
    LugaresService.getLugares().subscribe(lugares => {
        this.lugares = lugares.json();
        this.lugares = Object.keys(this.lugares).map((key) => this.lugares[key]);
        this.state ='final';

    }, error => {
      console.log(error)
      this.msg='<div class="bg-danger" style="padding:15px"><h4>Ups!...</h4>Ha ocurrido un error, estamos trabajando en eso: <strong>'+ error.statusText +'</strong></div>'
    })
*/
    this.AutorizacionService.isLogged()
      .subscribe((result)=> {
        if(result && result.uid){
          this.loggedIn=true;        
        }else{
          this.loggedIn=false;
        }
      }, (error)=>{
        this.loggedIn=false;
      })

  }



  ngOnInit() {
  }


}




// WEBPACK FOOTER //
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/lugares/lugares.component.ts